import React from 'react';

const ParkIcon = (props) => {
  return (
    <img
      alt="Góra"
      src="/static/images/icons/tourist_attractions/park.svg"
      {...props}
    />
  );
};

export default ParkIcon;
